/* sku.ad growth-loop — Shopify portu
   Kaynak: https://sku.ad/assets/scripts/growth-loop.js
   Degisiklikler: IIFE sarmalayici, oge basina tek-sefer korumasi,
   shopify:section:load ile yeniden kurulum.
*/
(function () {
const isTurkish = () => document.documentElement.lang === "tr";

const COPY = {
  roleSelected: (label) =>
    isTurkish() ? `${label} çalışma alanı seçildi.` : `${label} workspace selected.`,
  productMoved: (label) =>
    isTurkish() ? `${label} büyüme sistemine taşındı.` : `${label} moved into the growth system.`,
  demoPause: () => (isTurkish() ? "Duraklat" : "Pause"),
  demoPlay: () => (isTurkish() ? "Oynat" : "Play"),
  demoPaused: () => (isTurkish() ? "Ürün gösterimi duraklatıldı." : "Product demo paused."),
  demoResumed: () => (isTurkish() ? "Ürün gösterimi sürüyor." : "Product demo resumed."),
  adBuilding: () =>
    isTurkish() ? "Reklam kurulumu hazırlanıyor…" : "Building the advertising setup…",
  adReady: () =>
    isTurkish() ? "Reklam kurulumu yayına hazır." : "Advertising setup is ready to launch.",
  adLaunched: () =>
    isTurkish()
      ? "Kurulum tamam — yayına alma sku.ad çalışma alanınızda yapılır."
      : "Setup complete — launching happens in your sku.ad workspace.",
};

function kurGrowth() {
  for (const system of document.querySelectorAll("[data-growth-system]")) {
    // Tema editoru bolumu yeniden basabilir; iki kez baglanmasin.
    if (system.dataset.skuHazir) continue;
    system.dataset.skuHazir = "1";
  const roleChoices = [...system.querySelectorAll('input[name="growth-role"]')];
  const productChoices = [...system.querySelectorAll('input[name="product-choice"]')];
  const status = system.querySelector("[data-growth-status]");
  const productName = system.querySelector("[data-product-name]");
  const toggle = system.querySelector("[data-growth-toggle]");
  const toggleLabel = system.querySelector("[data-growth-toggle-label]");
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
  const cycleDelay = 3600;
  let cycleTimer = null;
  let pointerInside = false;
  let focusInside = false;
  let manualSelection = false;
  let userPaused = false;

  function labelFor(choice) {
    return system.querySelector(`label[for="${choice.id}"]`);
  }

  function markCurrent(choices, choice) {
    for (const item of choices) {
      const label = labelFor(item);
      if (!label) continue;
      // A bare toggleAttribute writes aria-current="", which resolves to the
      // default (false); the state has to be spelled out to register.
      if (item === choice) label.setAttribute("aria-current", "true");
      else label.removeAttribute("aria-current");
    }
  }

  function announce(text) {
    if (status) status.textContent = text;
  }

  function updateRole(choice, { announceChange = false, focus = false } = {}) {
    choice.checked = true;
    system.dataset.role = choice.value;
    markCurrent(roleChoices, choice);
    if (focus) choice.focus();
    if (announceChange) {
      announce(COPY.roleSelected(labelFor(choice)?.querySelector("span")?.textContent?.trim()));
    }
  }

  function updateProduct(choice, { announceChange = false, focus = false } = {}) {
    choice.checked = true;
    system.dataset.product = choice.value;
    const label = labelFor(choice)?.querySelector("span")?.textContent?.trim() ?? "";
    if (productName) productName.textContent = label;
    markCurrent(productChoices, choice);
    if (focus) choice.focus();
    if (announceChange) announce(COPY.productMoved(label));
  }

  function clearCycle() {
    if (cycleTimer !== null) {
      window.clearTimeout(cycleTimer);
      cycleTimer = null;
    }
  }

  function canCycle() {
    return (
      !userPaused &&
      !manualSelection &&
      !pointerInside &&
      !focusInside &&
      !document.hidden &&
      !reduceMotion.matches
    );
  }

  function scheduleCycle() {
    clearCycle();
    if (!canCycle() || roleChoices.length < 2 || productChoices.length < 2) return;
    cycleTimer = window.setTimeout(() => {
      const roleIndex = Math.max(
        0,
        roleChoices.findIndex((choice) => choice.checked),
      );
      const productIndex = Math.max(
        0,
        productChoices.findIndex((choice) => choice.checked),
      );
      updateRole(roleChoices[(roleIndex + 1) % roleChoices.length]);
      updateProduct(productChoices[(productIndex + 1) % productChoices.length]);
      scheduleCycle();
    }, cycleDelay);
  }

  function syncToggle() {
    const stopped = userPaused || manualSelection;
    if (toggleLabel) toggleLabel.textContent = stopped ? COPY.demoPlay() : COPY.demoPause();
    toggle?.setAttribute("aria-pressed", stopped ? "true" : "false");
  }

  function selectManually(choice, update) {
    manualSelection = true;
    clearCycle();
    syncToggle();
    update(choice, { announceChange: true, focus: true });
  }

  function bindChoiceGroup(choices, update) {
    for (const [index, choice] of choices.entries()) {
      choice.addEventListener("change", () => selectManually(choice, update));
      choice.addEventListener("keydown", (event) => {
        const previous = event.key === "ArrowLeft" || event.key === "ArrowUp";
        const next = event.key === "ArrowRight" || event.key === "ArrowDown";
        if (previous || next) {
          event.preventDefault();
          const offset = previous ? -1 : 1;
          selectManually(choices[(index + offset + choices.length) % choices.length], update);
        } else if (event.key === " " || event.key === "Enter") {
          event.preventDefault();
          selectManually(choice, update);
        }
      });
    }
  }

  bindChoiceGroup(roleChoices, updateRole);
  bindChoiceGroup(productChoices, updateProduct);

  toggle?.addEventListener("click", () => {
    const stopped = userPaused || manualSelection;
    if (stopped) {
      userPaused = false;
      manualSelection = false;
      announce(COPY.demoResumed());
      scheduleCycle();
    } else {
      userPaused = true;
      clearCycle();
      announce(COPY.demoPaused());
    }
    syncToggle();
  });

  system.addEventListener("pointerenter", () => {
    pointerInside = true;
    clearCycle();
  });
  system.addEventListener("pointerleave", () => {
    pointerInside = false;
    scheduleCycle();
  });
  system.addEventListener("focusin", () => {
    focusInside = true;
    clearCycle();
  });
  system.addEventListener("focusout", (event) => {
    if (!system.contains(event.relatedTarget)) {
      focusInside = false;
      scheduleCycle();
    }
  });
  document.addEventListener("visibilitychange", scheduleCycle);
  reduceMotion.addEventListener?.("change", () => {
    syncToggle();
    scheduleCycle();
  });

  const initialRole = roleChoices.find((choice) => choice.checked) ?? roleChoices[0];
  const initialProduct = productChoices.find((choice) => choice.checked) ?? productChoices[0];
  if (initialRole) updateRole(initialRole);
  if (initialProduct) updateProduct(initialProduct);
  // Reduced motion never starts the cycle, so the control has nothing to offer.
  if (toggle && reduceMotion.matches) toggle.hidden = true;
  syncToggle();
  scheduleCycle();
}

}

function kurAdSetup() {
  for (const story of document.querySelectorAll("[data-ad-setup]")) {
    if (story.dataset.skuHazir) continue;
    story.dataset.skuHazir = "1";
  const steps = [...story.querySelectorAll("[data-ad-step]")];
  const replay = story.querySelector("[data-ad-replay]");
  const launch = story.querySelector("[data-ad-launch-button]");
  const status = story.querySelector("[data-ad-status]");
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
  const stepDelay = 380;
  let timers = [];
  let hasPlayed = false;

  function clearTimers() {
    for (const timer of timers) window.clearTimeout(timer);
    timers = [];
  }

  function setReady(ready, message) {
    story.dataset.ready = ready ? "true" : "false";
    if (launch) launch.disabled = !ready;
    if (status && message) {
      status.textContent = message;
      status.removeAttribute("data-launched");
    }
  }

  function showFinalState() {
    clearTimers();
    story.removeAttribute("data-enhanced");
    for (const step of steps) step.classList.add("is-visible");
    setReady(true, COPY.adReady());
  }

  function play() {
    if (document.hidden || reduceMotion.matches) {
      showFinalState();
      return;
    }
    hasPlayed = true;
    clearTimers();
    story.dataset.enhanced = "true";
    setReady(false, COPY.adBuilding());
    for (const step of steps) step.classList.remove("is-visible");
    steps.forEach((step, index) => {
      timers.push(
        window.setTimeout(() => {
          step.classList.add("is-visible");
          if (index === steps.length - 1) setReady(true, COPY.adReady());
        }, index * stepDelay),
      );
    });
  }

  replay?.addEventListener("click", play);
  launch?.addEventListener("click", () => {
    if (story.dataset.ready !== "true" || !status) return;
    status.textContent = COPY.adLaunched();
    status.setAttribute("data-launched", "true");
  });
  reduceMotion.addEventListener?.("change", () => {
    if (reduceMotion.matches) showFinalState();
  });
  document.addEventListener("visibilitychange", () => {
    if (document.hidden) showFinalState();
  });

  if (reduceMotion.matches) {
    showFinalState();
  } else if ("IntersectionObserver" in window) {
    // Arm the dimmed state before the section is reachable, so the reveal never
    // reads as content that was visible and then faded out.
    story.dataset.enhanced = "true";
    // No message here: role="status" would announce it on page load, before
    // the section is reachable. play() sets it when the reveal starts.
    setReady(false);
    for (const step of steps) step.classList.remove("is-visible");
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting) && !hasPlayed) {
          observer.disconnect();
          play();
        }
      },
      { threshold: 0.28 },
    );
    observer.observe(story);
  } else {
    showFinalState();
  }
}
}

/* Shopify: bolum tema editorunde yeniden basilabilir, o yuzden
   shopify:section:load'da da kurulur. */
function kur() {
  kurGrowth();
  kurAdSetup();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", kur);
} else {
  kur();
}
document.addEventListener("shopify:section:load", kur);

})();
